import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, MapPin, MessageCircle } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#292927] text-[#F9F8F6] mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="/betherapy-logo.png" 
                alt="Betherapy" 
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-[#A0A09A] text-sm leading-relaxed">
              Conectando você aos melhores profissionais de saúde mental, mentoria e orientação espiritual.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Navegação</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/professionals" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Profissionais
                </Link>
              </li>
              <li>
                <Link to="/match" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Encontre seu Match
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Cadastre-se
                </Link>
              </li>
            </ul>
          </div>

          {/* Professional Types */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Especialidades</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/professionals?type=therapist" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Terapeutas
                </Link>
              </li>
              <li>
                <Link to="/professionals?type=coach" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Mentores
                </Link>
              </li>
              <li>
                <Link to="/professionals?type=spiritualist" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
                  Espiritualistas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-[#A0A09A] text-sm">
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                sac@betherapy.ai
              </li>
              <li className="flex items-center gap-2 text-[#A0A09A] text-sm">
                <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                <button onClick={() => window.dispatchEvent(new CustomEvent('open-ai-help'))} className="hover:text-[#F9F8F6] transition-colors cursor-pointer">
                  Agente AI de Ajuda
                </button>
              </li>
              <li className="flex items-center gap-2 text-[#A0A09A] text-sm">
                <MapPin className="w-4 h-4" strokeWidth={1.5} />
                Newcastle Upon Tyne, UK
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#3D3D3B] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#A0A09A] text-sm">
            © {new Date().getFullYear()} Betherapy. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
              Privacidade
            </Link>
            <Link to="/terms" className="text-[#A0A09A] hover:text-[#F9F8F6] transition-colors text-sm">
              Termos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
